import { render, staticRenderFns } from "./ContratosReajuste.vue?vue&type=template&id=4e57d7d4&"
import script from "./contratosReajuste.js?vue&type=script&lang=js&"
export * from "./contratosReajuste.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports